import { render, staticRenderFns } from "./date-range-menu.vue?vue&type=template&id=10c97c23&scoped=true"
import script from "./date-range-menu.vue?vue&type=script&lang=js"
export * from "./date-range-menu.vue?vue&type=script&lang=js"
import style0 from "./date-range-menu.vue?vue&type=style&index=0&id=10c97c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c97c23",
  null
  
)

export default component.exports